import {
  Box,
  colors,
  Divider,
  Grid,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { IndianCurrency } from "app/utils/helper";
import React from "react";

const PaymentSummaryComponent = ({
  showUpperSection = false,
  showLowerSection = false,
  showRazorpay = false,
  showHdfc = false,
  t_CashMode,
  t_NEFTMode,
  t_UpiMode,
  t_ChequeMode,
  t_CardMode,
  t_Razorpay,
  t_HdfcPG,
  totalDiscount,
  totalNetpaid,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 1024px)");

  const columns =
    showRazorpay && showHdfc ? 18 : showRazorpay || showHdfc ? 15 : 12;

  const feeBoxWidth = isMobile
    ? "100%"
    : isTablet
      ? "95%"
      : showRazorpay && showHdfc
        ? "100%"
        : showRazorpay || showHdfc
          ? "85%"
          : "70%";

  return (
    <>
      <FeeBox
        sx={{
          width: feeBoxWidth,
          padding: isMobile ? "3px" : "6px",
        }}
      >
        {showUpperSection && (
          <Grid
            container
            spacing={isMobile ? 1 : 2}
            columns={isMobile ? 12 : columns}
            wrap="wrap"
          >
            <Grid item xs={isMobile ? 4 : 3}>
              <PaymentItem>
                <Typography color={"gray"} variant="h6">
                  CASH Mode
                </Typography>
                <Typography variant="h6">
                  {IndianCurrency(t_CashMode)}
                </Typography>
              </PaymentItem>
            </Grid>
            <Grid item xs={isMobile ? 4 : 2}>
              <PaymentItem>
                <Typography color={"gray"} variant="h6">
                  NEFT
                </Typography>
                <Typography variant="h6">
                  {IndianCurrency(t_NEFTMode)}
                </Typography>
              </PaymentItem>
            </Grid>
            <Grid item xs={isMobile ? 4 : 2.5}>
              <PaymentItem>
                <Typography color={"gray"} variant="h6">
                  UPI
                </Typography>
                <Typography variant="h6">
                  {IndianCurrency(t_UpiMode)}
                </Typography>
              </PaymentItem>
            </Grid>
            <Grid item xs={isMobile ? 4 : 2.5}>
              <PaymentItem>
                <Typography color={"gray"} variant="h6">
                  Cheque
                </Typography>
                <Typography variant="h6">
                  {IndianCurrency(t_ChequeMode)}
                </Typography>
              </PaymentItem>
            </Grid>
            <Grid item xs={isMobile ? 4 : 2}>
              <PaymentItem>
                <Typography color={"gray"} variant="h6">
                  Card
                </Typography>
                <Typography variant="h6">
                  {IndianCurrency(t_CardMode)}
                </Typography>
              </PaymentItem>
            </Grid>
            {showRazorpay && (
              <Grid item xs={isMobile ? 4 : 3}>
                <PaymentItem>
                  <Typography
                    sx={{
                      fontSize: isMobile ? "12px" : "14px",
                      fontWeight: 500,
                      color: "#6B7280",
                    }}
                  >
                    Razor Pay
                  </Typography>
                  <Typography
                    style={{
                      fontWeight: 600,
                      fontSize: isMobile ? "12px" : "14px",
                      marginTop: "2px",
                    }}
                  >
                    {IndianCurrency(t_Razorpay)}
                  </Typography>
                </PaymentItem>
              </Grid>
            )}
            {showHdfc && (
              <Grid item xs={isMobile ? 4 : 3}>
                <PaymentItem>
                  <Typography
                    sx={{
                      fontSize: isMobile ? "12px" : "14px",
                      fontWeight: 500,
                      color: "#6B7280",
                    }}
                  >
                    HDFC PG
                  </Typography>
                  <Typography
                    style={{
                      fontWeight: 600,
                      fontSize: isMobile ? "12px" : "14px",
                      marginTop: "2px",
                    }}
                  >
                    {IndianCurrency(t_HdfcPG)}
                  </Typography>
                </PaymentItem>
              </Grid>
            )}
          </Grid>
        )}
        {showLowerSection && (
          <>
            <Divider
              sx={{ backgroundColor: "#0C2F49", my: isMobile ? 1.5 : 2 }}
            />
            <Grid container spacing={isMobile ? 1.5 : 2}>
              {totalDiscount && (
                <Grid item xs={isMobile ? 4 : 3}>
                  <SummaryItem>
                    <Typography
                      sx={{
                        fontSize: isMobile ? "12px" : "14px",
                        fontWeight: 500,
                        color: "#6B7280",
                      }}
                    >
                      Total Discount
                    </Typography>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: isMobile ? "12px" : "14px",
                        color: "#29DB5B",
                        marginTop: "2px",
                      }}
                    >
                      {IndianCurrency(totalDiscount)}
                    </Typography>
                  </SummaryItem>
                </Grid>
              )}
              <Grid item xs={isMobile ? 4 : 3}>
                <SummaryItem>
                  <Typography
                    sx={{
                      fontSize: isMobile ? "12px" : "14px",
                      fontWeight: 500,
                      color: "#6B7280",
                    }}
                  >
                    Total Net Paid
                  </Typography>
                  <Typography
                    style={{
                      fontWeight: 600,
                      fontSize: isMobile ? "12px" : "14px",
                      color: colors.blue[600],
                      marginTop: "2px",
                    }}
                  >
                    {IndianCurrency(totalNetpaid)}
                  </Typography>
                </SummaryItem>
              </Grid>
            </Grid>
          </>
        )}
      </FeeBox>
    </>
  );
};

export default PaymentSummaryComponent;

const FeeBox = styled(Box)`
  border-radius: 12px;
  border: 1px solid rgba(19, 115, 229, 0.2);
  background: rgba(39, 137, 253, 0.02);
  padding: 16px;
  display: inline-block;
  margin-top: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  @media (max-width: 768px) {
    display: block;
  }
`;

const PaymentItem = styled(Box)`
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(39, 137, 253, 0.05);
  }
`;

const SummaryItem = styled(Box)`
  padding: 8px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.5);
`;
